import Vue from 'vue'
import appConfig from './AppConfig'
import { Mapper } from './Mapper'

export class LocationIQGeocoder {
  mapper = Mapper.instance
  url = 'https://us1.locationiq.org/v1/search.php'
  searchResults = null

  search(query) {
    let params = {
      key: appConfig.locationIQToken,
      format: 'json',
      addressdetails: 1,
      normalizecity: 1,
      viewbox: this.getViewboxString(),
      q: query
    }

    return Vue.axios.get(this.url, { params: params }).then(
      response => {
        this.searchResults = response.data
        // this.logResults()
        this.processResults()
        this.checkForDuplicates()

        return this.searchResults
      },
      () => {
        // we get 404 errors when no results are found
        // console.log('search error', _err)
        return false
      }
    )
  }

  processResults() {
    this.filterResults()
    this.searchResults.forEach(result => {
      this.setResultTypeFields(result)
      this.setResultTitleFields(result)
    })
  }

  filterResults() {
    const filteredResults = this.searchResults.filter(result => {
      return result.type && result.importance > 0.3
    })

    if (filteredResults.length > 0) {
      this.searchResults = filteredResults
    }
  }

  setResultTypeFields(result) {
    result.icon = 'mdi-map-marker'
    result.iconClass = 'blue-darken-3'

    switch (result.class) {
      case 'boundary':
        this.setBoundaryFields(result)
        return
      case 'building':
        this.setBuildingFields(result)
        return
      case 'shop':
      case 'amenity':
        this.setShopFields(result)
        return
    }

    switch (result.type) {
      case 'island':
        this.setIslandFields(result)
        return

      case 'locality':
      case 'city':
      case 'village':
      case 'hamlet':
        this.setCityFields(result)
        return
      case 'suburb':
        this.setSuburbFields(result)
        return
      case 'house':
        this.setBuildingFields(result)
        return
      default:
        this.setDefaultResultTypeFields(result)
    }
  }

  setResultTitleFields(result) {
    const parts = result.displayText.split(', ')
    const titleParts = parts.slice(0, 2)
    const subtitleParts = parts.slice(2)

    result.title = titleParts.join(', ')
    result.subtitle = subtitleParts.join(', ')
  }

  setIslandFields(result) {
    result.displayText = `${result.address.island}, ${result.address.state}`
    this.maybeAddCountry(result)
  }

  setCityFields(result) {
    const address = result.address

    result.displayText = `${address.city}, ${address.state}`
    this.maybeAddCountry(result)

    const matchingResult = this.findResultByDisplayText(result.displayText)

    if (matchingResult) {
      if (matchingResult.importance === result.importance) {
        result.hide = true
        console.log(`hiding matching city: ${matchingResult}`)
      } else {
        result.displayText = `${address.city}, ${address.county}, ${address.state}`
        this.maybeAddCountry(result)
        console.log(
          `adding county to matching city: ${result.displayText}`
        )
      }
    }
  }

  setSuburbFields(result) {
    result.displayText = `${result.address.suburb}, ${result.address.city}, ${result.address.state}`
    this.maybeAddCountry(result)
  }

  setBuildingFields(result) {
    var address = result.address

    result.displayText =
      this.valueStringComma(this.street(address)) + this.cityState(address)

    this.maybeAddCountry(result)
    result.zoom = 15
  }

  setBoundaryFields(result) {
    const address = result.address

    result.displayText =
      this.valueStringComma(address.city) +
      this.valueStringComma(address.county) +
      this.valueString(address.state)

    this.maybeAddCountry(result)
    result.icon = 'mdi-map-marker-radius'
  }

  setShopFields(result) {
    const address = result.address
    const shopName = this.valueStringComma(address[result.type])

    result.displayText =
      shopName +
      this.valueStringComma(this.street(address)) +
      this.cityState(address)

    this.maybeAddCountry(result)

    result.zoom = 15
  }

  setDefaultResultTypeFields(result) {
    const address = result.address
    const placeName = this.valueStringComma(address.name)

    result.displayText =
      placeName +
      this.valueStringComma(this.street(address)) +
      this.cityState(address)

    this.maybeAddCountry(result)
    result.zoom = 12
  }

  findResultByDisplayText(displayText) {
    return this.searchResults.find(result => {
      return result.displayText === displayText
    })
  }

  valueString(value) {
    return value ? value : ''
  }

  valueStringComma(value) {
    const valueStr = this.valueString(value)
    return valueStr ? `${valueStr}, ` : ''
  }

  street(address) {
    const houseNumber = this.valueString(address.house_number)
    const road = this.valueString(address.road)

    return houseNumber ? `${houseNumber} ${road}` : road
  }

  cityState(address) {
    const city = this.valueStringComma(address.city)
    return city + this.valueString(address.state)
  }

  checkForDuplicates() {
    const displayTexts = []

    this.searchResults.forEach(result => {
      if (displayTexts.includes(result.displayText)) {
        // console.log(`hide: ${result.displayText}`)
        result.hide = true
      } else {
        displayTexts.push(result.displayText)
      }
    })

    if (!this.searchResults.length) {
      this.searchResults = undefined
    }
  }

  maybeAddCountry(result) {
    if (result.address.country_code === 'us') {
      return
    }

    const country = result.address.country
    result.displayText += result.displayText ? `, ${country}` : country
  }

  getViewboxString() {
    const bounds = this.mapper.getBounds()
    const swCoords = bounds[0]
    const neCoords = bounds[1]

    return swCoords.concat(neCoords).join(',')
  }

  logResults() {
    this.searchResults.forEach(result => {
      this.logResult(result)
    })
  }

  logResult(result) {
    console.log(
      `class: ${result.class}, ` +
        `type: ${result.type}, ` +
        `importance: ${result.importance}, ` +
        `display name: ${result.display_name}`
    )
    console.log('address', result.address)
  }
}
